module.exports = __webpack_public_path__ + "static/img/index-t1.36a86fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/index-t1.jpg
// module id = Rokr
// module chunks = 11